import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';

import XIcon from '../../icons/x_header.png';
import Viber from '../../icons/viber.jpeg';
import Instagram from '../../icons/instagram.jpeg';
import Telegram from '../../icons/telegram.jpeg';

import TextField from '../TextField/TextField';

import { changeSearch, changePagination } from '../../db/search';

import { useQueryParams } from '../../hooks/useQueryParams';

import './header.css';
import { CustomSelect } from '../CustomSelect/CustomSelect';

const Header = (props) => {
  const {
    cart = [],
    history,
    changeSearch,
    changePagination,
    instagram,
    telegram,
    viber,
    phone,
    phoneOptions,
  } = props;

  const [searchString, setSearchString] = useState('');
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const { changeQueryString } = useQueryParams(props);

  const handleSearch = () => {
    changeSearch(searchString);
    changePagination({ page: 1 });
    changeQueryString({ page: 1, query: searchString });

    if (!history.location.pathname.includes('catalog')) {
      history.push(`/catalog?query=${searchString}`);
    }

    if (Number(searchString) && searchString.length >= 8) {
      history.push(`/catalog?query=${searchString}`);
    }
  };

  const keyPress = (e) => {
    if (e.keyCode === 13) {
      handleSearch();
    }
  };

  useEffect(() => {
    setShowMobileMenu(false);
  }, [history.location.pathname]);

  return (
    <>
      {showMobileMenu && (
        <div className='menu-mobile'>
          <div className='menu-mobile__item'>
            <div className='footer__column'>
              <Link to='/about_us'>Про нас</Link>
              <Link to='/page/how_to_order'>Як замовити</Link>
              <Link to='/delivery'>Доставка і оплата</Link>
            </div>
            <div className='footer__column'>
              <Link to='/page/warranty'>Гарантія</Link>
              <Link to='/news'>Новини</Link>
              <Link to='/contacts'>Контакти</Link>
            </div>
          </div>
          <div className='menu-mobile__item'>
            <CustomSelect
              value={phone}
              className='phone phone-dropdown flex-container--bottom-10'
              options={phoneOptions}
            >
              {phone}
            </CustomSelect>
            <div className='socials flex-container--bottom-10'>
              <a href={viber} target='_blank' rel='noopener noreferrer'>
                <img src={Viber} alt='viber' />
              </a>
              <a href={instagram} target='_blank' rel='noopener noreferrer'>
                <img src={Instagram} alt='instagram' />
              </a>
              <a href={telegram} target='_blank' rel='noopener noreferrer'>
                <img src={Telegram} alt='telegram' />
              </a>
            </div>
            <div className='email flex-container--bottom-10'>xpartforparts@gmail.com</div>
            <a
              className='email-link flex-container--bottom-10'
              href='mailto:xpart.in.ua@gmail.com?subject=Question from user'
              target='_blank'
              rel='noopener noreferrer'
            >
              Надіслати лист на пошту
            </a>
          </div>
        </div>
      )}
      <header>
        <div className='section__content'>
          <div className='header--mobile'>
            <img
              src={
                showMobileMenu
                  ? 'https://img.icons8.com/ios-glyphs/30/0096d0/delete-sign.png'
                  : 'https://img.icons8.com/material-outlined/24/0096d0/menu--v1.png'
              }
              width={23}
              height={23}
              alt='burger-menu'
              onClick={() => setShowMobileMenu((prevShowMobileMenu) => !prevShowMobileMenu)}
            />
            <a href='/'>
              <div className='flex-container--center'>
                <img src={XIcon} alt='xpart-icon' width={49} height={51} />
                <div className='page__logo-text'>-Part</div>
              </div>
            </a>
            <Link to='/basket'>
              <div className='shopping-cart'>
                <div className='shopping-cart__count'>{cart.length}</div>
                <img
                  src='https://img.icons8.com/sf-regular-filled/48/ffffff/shopping-cart.png'
                  width={35}
                  height={35}
                  alt='shopping-cart'
                />
              </div>
            </Link>
          </div>

          <div className='header--desktop'>
            <div className='flex-container--between header__left'>
              <a href='/'>
                <div className='flex-container--center'>
                  <img src={XIcon} alt='xpart-icon' width={49} height={51} />
                  <div className='page__logo-text'>-Part</div>
                </div>
              </a>
              <TextField
                className='page__search-field'
                placeholder='Пошук по сайту'
                onChange={(e) => {
                  setSearchString(e.target.value);
                }}
                onKeyDown={keyPress}
                onIconClick={handleSearch}
                value={searchString}
                icon='https://img.icons8.com/ios-filled/16/787878/search--v1.png'
              />
              <div className='flex-container--column' style={{ width: '35%' }}>
                <div className='flex-container--between'>
                  <div className='email'>xpartforparts@gmail.com</div>
                  <CustomSelect
                    value={phone}
                    className='phone phone-dropdown flex-container--bottom-10'
                    options={phoneOptions}
                  >
                    {phone}
                  </CustomSelect>
                </div>
                <div className='flex-container--between'>
                  <a
                    className='email-link'
                    href='mailto:xpart.in.ua@gmail.com?subject=Question from user'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Надіслати лист на пошту
                  </a>
                  <div className='socials'>
                    <a href={viber} target='_blank' rel='noopener noreferrer'>
                      <img src={Viber} alt='viber' />
                    </a>
                    <a href={instagram} target='_blank' rel='noopener noreferrer'>
                      <img src={Instagram} alt='instagram' width={27} height={27} />
                    </a>
                    <a href={telegram} target='_blank' rel='noopener noreferrer'>
                      <img src={Telegram} alt='telegram' width={27} height={27} />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <Link to='/basket'>
              <div className='shopping-cart'>
                <div className='shopping-cart__count'>{cart.length}</div>
                <img
                  src='https://img.icons8.com/sf-regular-filled/48/ffffff/shopping-cart.png'
                  width={35}
                  height={35}
                  alt='shopping-cart'
                />
              </div>
            </Link>
          </div>
        </div>
      </header>
      <div className='page__search section__content'>
        <TextField
          className='page__search-field'
          placeholder='Пошук по сайту'
          onChange={(e) => {
            setSearchString(e.target.value);
          }}
          onKeyDown={keyPress}
          onIconClick={handleSearch}
          value={searchString}
          icon='https://img.icons8.com/ios-filled/16/787878/search--v1.png'
        />
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    cart: state.cart,
    user: state.user,
    search: state.search,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ changeSearch, changePagination }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Header));
